export { MorphemeInfoPanelDictionaryStatRow } from "#morpheme-info-panel-dictionary-stat-row";
